import React from 'react'
import { useParams } from 'react-router-dom'
import GroupDetails from './GroupDetails'

const GroupDetailsWrapper = (props) => {
    const params = useParams()
    return <GroupDetails {...props} params={params} />
}

export default GroupDetailsWrapper
